export default __webpack_public_path__ + "static/media/compass.d02474a1.svg";